import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { HashSet } from "../../../utils/HashSet";
import { useModalV2 } from "../../AppModals";
import { AppButton } from "../../Generic/AppButton";
import { EligibleInstaPayVisit, formatCentsToDollars } from "../SelectInstaPayVisitsScreen";

type Props = {
  selectedVisits: HashSet<EligibleInstaPayVisit>;
  onClick: () => void;
};

export default function PayrollButton(props: Props) {
  const modals = useModalV2();

  const selectedBalance = formatCentsToDollars(
    props.selectedVisits.reduce((acc, visit) => acc + visit.status.eligibleAmount, 0)
  );

  const handleClickDisabled = () => {
    modals.createModal({
      type: "info",
      title: translate(STRINGS.NO_VISITS_SELECTED),
      message: translate(STRINGS.IN_ORDER_TO_GET_INSTAPAID_YOU_NEED_TO_SELECT_AT_LEAST_ONE_VISIT),
    });
  };

  return (
    <ButtonRoot>
      {props.selectedVisits.size() === 0 ? (
        <AppButton
          size="large"
          color="black"
          block={true}
          className="disabled"
          onClick={handleClickDisabled}
        >
          {translate(STRINGS.NO_VISITS_SELECTED)}
        </AppButton>
      ) : (
        <AppButton color="sexy" onClick={props.onClick} block={true}>
          {translate(STRINGS.CONTINUE)} ({selectedBalance})
        </AppButton>
      )}
    </ButtonRoot>
  );
}

const ButtonRoot = styled.div`
  padding: 16px;
`;
